// src/components/bsm/StickyConversionDock.js
import React, { useState, useEffect } from 'react';
import { WhatsAppIcon, CloseIcon } from './BsmIcons';

export default function StickyConversionDock({ onOpenCounseling }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 480) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible || isDismissed) return null;

  return (
    <div className="sticky-conversion-dock" role="region" aria-label="Quick Admission Desk">
      <div className="dock-inner">
        <div className="dock-info">
          <div className="dock-status-row">
            <span className="dock-pulse-dot" />
            <span className="dock-status-text">Pune Classroom &amp; Online Batches Open</span>
          </div>
          <span className="dock-batch-meta">Upcoming Cohort • Limited to 15 Seats</span>
        </div>

        <div className="dock-actions">
          <button
            type="button"
            className="btn-dock-counseling"
            onClick={() => onOpenCounseling('Sticky Dock Admission Request')}
          >
            <span>Book Free Demo &amp; Counseling →</span>
          </button>
          
          <a
            href="https://api.whatsapp.com/send?phone=918177887927&text=Hello%20Brilliant%20Share%20Market%20Academy,%20I%20would%20like%20to%20know%20about%20upcoming%20batch%20dates%20and%20counseling%20at%20Akurdi."
            target="_blank"
            rel="noreferrer"
            className="btn-dock-whatsapp"
            aria-label="Direct WhatsApp Enquiry"
          >
            <WhatsAppIcon width={15} height={15} />
            <span>WhatsApp Desk</span>
          </a>

          <button
            type="button"
            className="btn-dock-dismiss"
            onClick={() => setIsDismissed(true)}
            aria-label="Dismiss quick dock"
          >
            <CloseIcon width={14} height={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
